// default-password.guard.ts
import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from './auth.service';
import { ChangePasswordModalComponent } from '../../change-password-modal/change-password-modal.component'

export const defaultPasswordGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const dialog = inject(MatDialog);
  const router = inject(Router);

  const currentUser = authService.currentUserValue;

  if (currentUser?.isDefaultPassword) {
    // Open modal after a short delay
    setTimeout(() => {
      dialog.open(ChangePasswordModalComponent, {
        width: '550px',
        maxWidth: '90vw',
        panelClass: 'change-password-dialog',
        disableClose: true,
        autoFocus: true
      });
    }, 300);
  }

  return true;
};
